import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import gajiPotonganService from "../../services/gajiPotonganService";

export const initialState = {
    loading_gaji_potongan: false,
    data_gaji_potongan: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataGajiPotongan = createAsyncThunk('gaji_potongan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPotonganService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('gaji_potongan/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPotonganService.data_import(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('gaji_potongan/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPotonganService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('gaji_potongan/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPotonganService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const gajiPotonganSlice = createSlice({
    name: 'gaji_potongan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_gaji_potongan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataGajiPotongan.fulfilled, (state, action) => {
                state.loading_gaji_potongan = false
                state.data_gaji_potongan = action.payload??[]
            })
            .addCase(getDataGajiPotongan.pending, (state) => {
                state.loading_gaji_potongan = true
            })
            .addCase(getDataGajiPotongan.rejected, (state, action) => {
                state.loading_gaji_potongan = false
                state.data_gaji_potongan = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_gaji_potongan = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_gaji_potongan = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_gaji_potongan = false
                state.data_import = action.payload
            })

    },
})

export const {
    showLoading,
} = gajiPotonganSlice.actions

export default gajiPotonganSlice.reducer
